import { createApi } from "@reduxjs/toolkit/query/react";

import { customBaseQuery } from "./utils";

export const baseApi = createApi({
  baseQuery: customBaseQuery,
  tagTypes: ['GameScore'],
  endpoints: () => ({}),
});
